import Flickity from "flickity";

class ConfiguratorSlider {
	constructor(config) {
		this.config = Object.assign({
			scope: '.configurator-wrap',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		console.log('test');
		this.$scope.each((index, element) => {
			let flickity = Flickity.data(element);

			flickity.on('pointerUp', (event, pointer) => {
				flickity.next(true);
				flickity.player.play();
			})
		});
	}
}

export default new ConfiguratorSlider;
